export default {
  get(name) {
    return JSON.parse(localStorage.getItem(name))
  },
  set(name, data) {
    localStorage.setItem(name, JSON.stringify(data))
  },
  remove(name) {
    localStorage.removeItem(name)
  },
}
